import React from 'react';
import { Dialog } from '@askporter/component-library/Dialog';
export interface ExportLimitDialogProps {
  /**
   * Whether the dialog is open
   */
  isOpen: boolean;
  /**
   * callback to close the dialog
   */
  onClose: () => void;
  /**
   * The translation function
   */
  t: (key: string, options?: Record<string, string | number>) => string;
  /**
   * apply filters callback
   */
  applyFilters: () => void;
  /**
   * proceed with export callback
   */
  proceedWithExport: () => void;
}
export const ExportLimitDialog = ({
  isOpen,
  onClose,
  t,
  applyFilters,
  proceedWithExport,
}: ExportLimitDialogProps): JSX.Element => {
  return (
    <Dialog
      isOpen={isOpen}
      dialogHeaderIcon="error"
      dialogHeaderProps={{
        title: t('common:export:export_limit_dialog:title'),
        onClose: onClose,
      }}
      dialogActionProps={{
        buttons: [
          {
            label: t('common:export:export_limit_dialog:apply_button'),
            variant: 'outlined',
            onClick: applyFilters,
          },
          {
            label: t('common:export:export_limit_dialog:proceed_button'),
            variant: 'contained',
            onClick: proceedWithExport,
          },
        ],
      }}
    >
      {t('common:export:export_limit_dialog:content')}
    </Dialog>
  );
};
